module.exports = __webpack_public_path__ + "img/unidad_no_disponible-naranja.57cf4ed3.png";